<template>
  <div class="view-report" >
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
      <span>首页</span>>
      <span><router-link :to="{name:'HospitalImage'}">本院影像</router-link></span> >
      <span>查看报告</span>
    </div>
    <div class="patient-report">
      <div class="report-head">
        <div class="report-info">
          <b>{{report.examTypeName}}报告单</b>
        </div>
        <div class="report-btn">
          <a v-for="(btnTxt,index) in btnTxts" href="javascript:;" @click="RepOperation(index)" :class="{hui:index==2||index==0}">{{btnTxt}}</a>
        </div>
      </div>
      <reports :info="report"></reports>
    </div>

    <div class="list-num" @click="showHistory=!showHistory">历史检查：共查询到 <strong>{{historyList}}</strong> 条信息 <i
      class="el-icon-arrow-down"></i></div>

    <div class="history">
      <el-collapse-transition>
        <div class="historyList" v-show="showHistory">
          <div class="historyTable">
            <tables class="history-table" :readImageList="readImageList" :data="historyData" :showCheck="showCheck" :head="head" @showDetial="showDetials" @readImg="readImgs"></tables>
          </div>
          <div class="checkDetails">
            <div class="DetailHead">
              <span></span>
              <p v-show="currentRow.examTypeName">
                {{currentRow.examBodyName}}&nbsp/&nbsp{{currentRow.examTypeName}}&nbsp/&nbsp{{currentRow.studiesDoneDt}}</p>
              <!-- <a href="javascript:;" @click="ReadReport">阅片</a>-->
              </div>
            <div class="result-con">
              <div class="Image">
                <span>影像所见：</span>
                <p class="content" v-show="currentRow!=null">{{currentRow.reportEvidences}}</p>
              </div>
              <div class="Result">
                <span>诊断结果：</span>
                <p class="content" v-show="currentRow!=null">{{currentRow.reportConclusion}}</p>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>

    <pops :show="pops" @closePop="closePop" :width="popwidth" :title="title" :classes="'Collections'" class="collect">
      <elcRep v-show="popindex==0" :elcRep="elcRep" :emergent="emergent"></elcRep>
      <div slot="shoucang">
        <div class="record" v-show="popindex==4">
          <div class="record-left">
            <record v-if="popindex==4&&pops==true" @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl"
                    @delPerson="delPerson" @addPersonList="addPersonList" :showCheckBox="true"
                    :personList="personList" :treeData="treeData" @searchClick="searchClick"
                    :titleList="titleList" @checkTree="checkTree" @personChecked="personChecked"
                    :filterText="filterText">
            </record>
          </div>
          <div class="record-right" v-if="popindex==4&&pops==true">
            <medicalNew :info="CaseInfo" @detailUpdate="CollectRecord"></medicalNew>
          </div>
        </div>
      </div>
      <div slot="shoucang-btn" v-show="popindex==4"><a href="javascript:;" class="shoucang" @click="Collect">收藏</a></div>
      <div slot="shoucang-btn" v-show="popindex==0"><a href="javascript:;" class="shoucang" @click="closePop(false)">关闭</a></div>
    </pops>

    <aycanImages ref="aycanImages" :isBenYuan="true" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
  import {nomalTime,format} from '@/common/js/time'
  import {changehosArea,changeAge,changeGender,changeSex,yinyang,changeclinicType} from '@/common/js/change'
  import pReport from '@/components/common/report/publicReport'
  import reports from '@/components/common/report/publicReport'
  import elcRep from '@/components/common/report/electronicReport'
  import tables from '@/components/common/tables/reportTable'
  import pops from '@/components/common/pops/pop'
  import record from '@/components/common/collapseMedicalRecord/collapseMedicalRecord'
  import medicalNew from '@/components/common/medicalNews/medicalNews/'

  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'

  import aycanImages from '@/components/common/base/aycanImages'
  const btnTxts = ['查看申请单', '预览', '电子病历', '阅片', '收藏']

  export default {
    components: {
      pReport,
      reports,
      tables,
      pops,
      record,
      medicalNew,
      elcRep,
      aycanImages
    },
    data() {
      return {
        popindex: 0,
        popwidth: '',
        hospitalIdes:[],
        studyPks:[],
        studyUids:[],
        pops: false,
        emergent:false,
        readImgList:[],
        title: '电子申请单',
        showCheck: true,//显示勾选
        //showImage: true,
        //showResult: true,
        showHistory: false,
        btnTxts: btnTxts,
        report: {},
        historyReport:{},
        elcRep:{},
        imgSelect: {},
        head: [

          {
            props: 'hospitalName',
            label: '医院名称',
            width: '5%'
          },
          {
            props: 'patientId',
            label: '患者编号',
            width: '7%'
          },
          {
            props: 'accessionNumber',
            label: '检查编号',
            width: '7%'
          },
          {
            props: 'examTypeName',
            label: '检查类型',
            width: '5%'
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            width: '8%'
          },
          {
            props: 'examDate',
            label: '检查时间',
            width: '10%'
          },
          {
            props: 'reportEvidences',
            label: '影像所见',
            width: '10%'
          },
          {
            props: 'reportConclusion',
            label: '诊断结果',
            width: '10%'
          }
        ],

        historyData: [
          /*{
            hosArea: '解放院区1',
            mediId: '2018000001',
            examTypeName: 'CT',
            clinicType: '门诊',
            examBodyName: '头颅正侧位头颅正侧位',
            examDate: '2017-09-09 12:25',
            reportEvidences: "影像所见",
            reportConclusion: "诊断结果",
          },*/
        ],

        //收藏
        filterText: '',
        treeData: [],
        allTreeData: [],
        oldPersonList:[],
        tabs: [
          { label: "公共分类", name: "0" },
          { label: "个人分类", name: "1" }
        ],
        personList: [
          /*{ label: "个人病例1" },
          { label: "个人病例2" },
          { label: "个人病例3" }*/
        ],
        personCheckedList:[],
        titleList: [
          { title: "自定义分类", name: "4" },
          { title: "按诊断分类", name: "1" },
          { title: "按部位分类", name: "2" },
          { title: "按科室分类", name: "3" }
        ],
        CaseInfo: {
          caseName: '',
          caseSex: '',
          caseAge: '',
          ageUnit: '',
          remark: '',
          history: '',
          caseResult: '',
          evidence: '',
          dianogeResult: '',
          //index:'',
        },
        readImageList:[],
        studyList:{},
        catalogId:'', //所属类型id
        privateType:0,//公开级别

        currentRow: {
          hospitalId: '',
          studyPk:'',
          studyUid: ''
        },
        historyList: '0',
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        },
         checkList: {
          hospitalId: '',
          studyPk:'',
          studyUid: ''
        },
      }
    },
     mounted() {
      /*setTimeout(() => {
        this.historylistHeight()
      }, 50)*/
      let historyList = document.getElementsByClassName("historyList")[0];
      let historyTable = document.getElementsByClassName("historyTable")[0];
      setTimeout(() => {
        historyList.addEventListener('resize', () => {
          alert(historyList.offsetHeight)
          historyTable.style.height = historyList.offsetHeight + 'px'
        })
      }, 50)
      //获取报告单详情
      let rep = {
        hospitalId: sessionStorage.getItem('hospitalId'),
        studyPk: sessionStorage.getItem('studyPk'),
        studyUid: sessionStorage.getItem('studyUid'),
      };
      http.post(`/edu/ourHosReportDeatil.json?${Math.random()}`, rep).then(res => {
        if (res.data.code == "0000") {
          //console.log(res.data);
          res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag);
          res.data.model.patientSex = changeGender(res.data.model.patientSex);
          res.data.model.studiesDoneDt = nomalTime(res.data.model.studiesDoneDt);
          res.data.model.reportSdt = nomalTime(res.data.model.reportSdt);
          res.data.model.approveDt = nomalTime(res.data.model.approveDt);
          //res.data.model.reviseTime = nomalTime(res.data.model.reviseTime);
          res.data.model.clinicType = changeclinicType(res.data.model.clinicType)
          this.report = res.data.model;
          sessionStorage.setItem('zerRep', JSON.stringify(this.report));
          // res.data.model.patientAge = res.data.model.patientAge + changeAge(res.data.model.ageUnit)
          if(this.data[i].patientAge.indexOf('岁') > -1){
                this.data[i].patientAge= this.data[i].patientAge
              }else{
               this.data[i].patientAge = this.data[i].patientAge + changeAge(this.data[i].ageUnit)
            }

        }
      }).catch(() => {
      });
      //电子申请单
      // http.post('/edu/electApplication.json', rep).then(res => {
      //   //if (res.data.code == "0000") {
      //   if (res.data.success == true) {
      //     this.elcRep = res.data.model;
      //     this.Rep.patientSex = changeSex(this.Rep.patientSex)
      //     this.Rep.billApplyDate = changeSex(this.Rep.billApplyDate)
      //   }
      // }).catch(() => {
      // });
      //获取历史列表
      let his ={
        hospitalId: sessionStorage.getItem('hospitalId'),
        studyPk: sessionStorage.getItem('studyPk'),
      }
      //his.mediId = sessionStorage.getItem('mediId');
      http.post('/edu/historyCheckList.json', his).then(res => {
        if (res.data.code == "0000") {
          this.historyData = [];
          for (let i = 0; i < res.data.model.length; i++) {
            //if(res.data.model[i].studyPk == this.report.studyPk){continue;}
            res.data.model[i].examDate = nomalTime(res.data.model[i].examDate);
            res.data.model[i].hosArea = changehosArea(res.data.model[i].hosArea);
            res.data.model.clinicType = changeclinicType(res.data.model.clinicType)
            this.historyData.push(res.data.model[i]);
            this.historyList = this.historyData.length;
          }
        }
      }).catch(err => {
        console.log(err)
      });

    },
    methods: {
      //匿名化
      rep(val, type) {
        let temp = "";
        if (type == '1') {
          if (val.length > 2) {
            for (let i = 0; i < val.length; i++) {
              if (i == 0 || i == val.length - 1) {
                temp = temp + val.substring(i, i + 1);
              }
              else {
                temp = temp + "*";
              }
            }
          } else {
            temp = val.substring(0, 1) + '*';
          }
        } else {
          for (let j = 0; j < val.length - 4; j++) {
            temp = temp + "*";
          }
          temp = temp + val.substring(val.length - 5, val.length - 1)
        }
        return temp;
      },
      /*historylistHeight(){
        let innerH = document.getElementsByClassName('left')[0].clientHeight
        let repH = document.getElementsByClassName('patient-report')[0].clientHeight
        let crumbs = document.getElementsByClassName('crumbs')[0].clientHeight
        let search = document.getElementsByClassName('list-num')[0].clientHeight
//        80为页脚已经一些边距值的和
        //console.log(innerH)
        document.getElementsByClassName('history')[0].height = innerH - repH - crumbs - search + 130 + 'px'
        console.log(document.getElementsByClassName('history')[0].height)
      },*/
      closePop(val) {
        this.pops = val;
      },
      showDetials(val) {   // 影像历史详情

        //this.currentRow = val;
        let param = {};
        param.hospitalId = val.hospitalId;
        param.studyPk = val.studyPk;
        //param.studyUid = val.studyUID;
        param.studyUid = val.studyUid;
        //this.historyReport = param;
        //console.log(this.currentRow)
        http.post('/edu/ourHosReportDeatil.json', param).then(res => {
          if (res.data.code == "0000") {
            // let params_img={};
            // params_img.studyPk=res.data.model.studyPk;
            // params_img.studyUid=res.data.model.studyUid;
            // params_img.hospitalId=res.data.model.hospitalId;
            // res.data.model.studiesDoneDt = nomalTime(res.data.model.studiesDoneDt);
            // this.currentRow.examBodyName=res.data.model.examBodyName;
            // this.currentRow.examTypeNam=res.data.model.examTypeNam;
            this.currentRow.studiesDoneDt= nomalTime(res.data.model.studiesDoneDt);
            this.currentRow = res.data.model;
            // this.currentRow.studiesDoneDt=res.data.model.studiesDoneDt
            // this.currentRow.examBodyName =res.data.examBodyName
            // this.currentRow.examTypeName=res.data.examTypeName
          }else{
            this.currentRow = {}
          }
        }).catch(() => {
        })

      },

  readImgs(val) {
      this.readImageList=val;
      this.currentRow = val;
    for(let i=0;i<this.currentRow.length;i++){
      this.checkList.hospitalId=this.currentRow[i].hospitalId;
      this.checkList.studyPk= this.currentRow[i].studyPk;
        //param.studyUid = val.studyUID;
      this.checkList.studyUid= this.currentRow[i].studyUid;

      }
      let params={
       hospitalId:this.checkList.hospitalId,
        studyPk:this.checkList.studyPk,
        studyUid: this.checkList.studyUid
      }
       http.post('/edu/ourHosReportDeatil.json', params).then(res => {
           if (res.data.code == "0000") {
           // this.currentRow = res.data.model;
            this.currentRow.studiesDoneDt=nomalTime(res.data.model.studiesDoneDt)
            // this.currentRow.examBodyName =res.data.examBodyName
            // this.currentRow.examTypeName=res.data.examTypeName
            // this.reportEvidences
            this.currentRow=res.data.model
           }else{
            this.currentRow={}
         }
       }).catch(() => {
       })
      },
        //按钮
      RepOperation(index) {
        this.popindex = index;
        if (index == 0) {
          // this.pops = true;
          // this.popwidth = '960px'
          // this.title = '电子申请单'
          return;
        }
        if (index == 1) {
          this.$router.push({name: "zerReport", params: this.report})
          this.pops = true;
          return;
        }
        if (index == 2) {
          this.title = ''
          return;
        }
        if (index == 3) {
          const hospitalIdList=[];
          const studyPkList=[];
          const studyUidliset=[];
         if(this.readImageList.length>0 ){
        this.readImageList.forEach(item => {
          hospitalIdList.push(item.hospitalId);
          studyPkList.push(item.studyPk);
          studyUidliset.push(item.studyUid);
        });

        this.params_image.hospitalId =hospitalIdList.join(",")+','+sessionStorage.getItem('hospitalId');
        this.params_image.studyPk = studyPkList.join(",")+','+sessionStorage.getItem('studyPk')+"";
        this.params_image.studyUid =  studyUidliset.join(",")+','+sessionStorage.getItem('studyUid');
        this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
        })

      }else{
             this.params_image.hospitalId =sessionStorage.getItem('hospitalId');
             this.params_image.studyPk =sessionStorage.getItem('studyPk')+"";
             this.params_image.studyUid =sessionStorage.getItem('studyUid');
             this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
           })
        }
     }
          // let Aycan = {
          //   hospitalId: sessionStorage.getItem('hospitalId'),
          //   studyPk: sessionStorage.getItem('studyPk'),
          //   studyUid: sessionStorage.getItem('studyUid')
          // }
          // http.post('/edu/prepareAycanBenYuan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //     // window.open(res.data.model,'_blank');
          //     let url = res.data.model
          //     window.open(url)
          //   }else{
          //     message('影像调阅失败',false);
          //   }
          // }).catch(() => {
          // })

        if (index == 4) {
          this.pops = true;
          this.popwidth = '860px'
          this.title = '收藏到病例库'
          this._getTreeData();
          this._getTreeData(1);
          //this.CaseInfo.caseAge = this.report.patientAge.substr(0,this.report.patientAge.length-1);
          this.CaseInfo.caseAge = parseInt(this.report.patientAge);

          //this.CaseInfo.ageUnit = changeAge(this.report.patientAge);
          this.CaseInfo.ageUnit = changeAge(this.report.ageUnit);
          //this.CaseInfo.caseAge = this.report.patientAge
          this.CaseInfo.caseSex = changeSex(this.report.patientSex);
          this.CaseInfo.evidence = this.report.reportEvidences;
          this.CaseInfo.dianogeResult = this.report.reportConclusion;
          this.studyList.hospitalId = this.report.hospitalId;
          this.studyList.studyPk = this.report.studyPk;
        }
      },
     // let Aycan = {
        //   hospitalId:this.currentRow.hospitalId,
        //   studyPk: this.currentRow.studyPk,
        //   studyUid:this.currentRow.studyUid
        // }
        // http.post('/edu/prepareAycanBenYuan.json', Aycan).then(res => {
        //   if (res.data.code == "0000") {
        //       let url = res.data.model
        //       window.open(url)
        //   }else{
        //     message('影像调阅失败',false);
        //   }
        // }).catch(() => {
        // })
      //},

      //收藏病历库
      _getTreeData(privateType = 0, keyWord='', subType) {
        let parmars = {
          privateType,
          keyWord,
          subType
        };
        http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (privateType === 0) {
              this.allTreeData = res.data.model;
              this.changeColl('1')
            } else {
              this.oldPersonList = res.data.model;
              this.personList = res.data.model;
            }
          }
        });
      },
      changeColl(playlod) {
        // 1==>部位 2==>诊断 3==>科室
        this.filterText = ''
        this.treeData = []
        setTimeout(() => {
          // 1==>部位 2==>诊断 3==>科室
          let [flag, arr] = ['DIANOG', []];
          if (playlod === '1') {
            flag = 'DIANOG';
          } else if (playlod === '2') {
            flag = 'PART';
          } else if (playlod === '3') {
            flag = 'DEPT';
          } else {
            flag = 'CUSTOMER';
          }
          this.treeData = []
          arr = this.allTreeData.filter(item => item.subType === flag)
          for (let item of arr) {
            if (item.parentId === 0) {
              this.treeData.push({
                id: item.id,
                label: item.catalogName,
                children: this.allTreeData.filter(c => c.parentId ===  item.id)
              })
            }
          }
          for (let item of this.treeData) {
            if (item.children.length > 0) {
              for (let cItem of item.children) {
                cItem.label = cItem.catalogName
              }
            }
          }
        }, 400)
        //console.log(this.treeData)
      },
      addPersonList(val) {
        this.$prompt('请输入病例名', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
          // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          // inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          let parmars = {
            privateType: '1',
            catalogName:　value
          }
          http.post('catalog/addCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '提交成功'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      },
      delPerson(val) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let parmars = {
            id: val.id
          }
          http.post('catalog/deleteCaseCatalog.json', parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      tabChange(payload) {
        //console.log(payload);
        this.filterText = ''
        this.personList = this.oldPersonList
        this.personFlag = payload.name
       // console.log(this.personFlag)
        this.defaultTreeChecked = []
        this.defaultPersonListChecked = []
        this.personCheckedList =[]
        this.catalogId = []
        if (payload.name === "1") {
          this.isPerson = true;
        } else {
          this.isPerson = false;
        }
      },
      searchClick(val) {
        this.filterText = val
        this.personList = this.oldPersonList.filter(item => item.catalogName.indexOf(val)>-1)
      },
      checkTree(val){ //收藏 公共的传值
        let idList = [];
        for(let i=0;i<val.length;i++){
          idList.push(val[i].id)
          if(val[i].privateType!=undefined) { //privateType默认为0
            this.privateType = val[i].privateType;
          }
        }
        this.catalogId = idList.join(',');
        //console.log(this.privateType)
        //console.log(this.catalogId)
      },
      personChecked(val) {  //收藏 私有的传值
        this.personCheckedList = val;
        this.catalogId = this.personCheckedList.join(',');
        //console.log(this.catalogId)
      },

      CollectRecord(val){ //收藏 信息填写
        this.CaseInfo = val;
        //console.log('-----'+this.CaseInfo)
        //this.data[val.index].refId = 1;
      },
      /*点击收藏*/
      Collect(){
        if(this.catalogId==''){
          message('请选择收藏目录！',false)
          return;
        }
        if(this.CaseInfo.caseName==''){
          message('请填写必填项！',false)
          return;
        }
        let CaseInfo ={
          caseName:this.CaseInfo.caseName,
          caseSex: this.CaseInfo.caseSex,
          caseAge: this.CaseInfo.caseAge,
          ageUnit: this.CaseInfo.ageUnit,
          remark: this.CaseInfo.remark,
          history: this.CaseInfo.history,
          caseResult: this.CaseInfo.caseResult,
          evidence: this.CaseInfo.evidence,
          dianogeResult: this.CaseInfo.dianogeResult,
          catalogId:this.catalogId,
          privateType:this.personFlag,
          studyList:[
            {hospitalId:this.studyList.hospitalId,
              studyPk:this.studyList.studyPk},
          ]
        };
        http.post('/caselib/addCaseInfo.json', CaseInfo).then(res => {
          if (res.data.code == "SUCCESS") {
            this.pops = false;
            message('收藏成功，请前往病例库中查看！',true)
            this.CaseInfo = {};
            //this.data[this.CaseInfo.index].refId = 1;
          }else{
            message(res.data.msg,false)
          }
        }).catch(() => {
        });
      },
    },

    created() {
    },
    watch: {}
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .view-report
    float: left
    margin: 0 0 0 20px
    height: calc(100vh - 50px)
    overflow-y auto
    width: 96%

  .patient-report
    background: $color-background-d
    .report-head
      width: 98%
      height: 34px
      margin: 0 auto
      padding: 1%
      overflow: hidden
      position: relative
      .report-info
        line-height: 28px
        text-align: center
        font-size: 16px
        color: #000
        b
          font-weight bold
      .report-btn
        position: absolute
        right: 12px
        top: 12px
        a
          display: inline-block
          width: 80px
          height: 28px
          line-height: 28px
          background: $color-background-hover
          color: $color-background-d
          text-align: center
          margin-left: 10px
          border-radius: 3px

  .list-num
    margin-top: 20px
    text-indent: 10px
    line-height: 30px
    font-size: 14px
    background: $color-background-d
    strong
      color: $color-background-hover
    i
      float: right
      margin: 10px 20px 0 0
      width: 16px
      height: 16px

  .history
    height auto
    overflow-y: auto
    .historyList
      padding-top: 10px
      border-top: 1px solid #E8E9EB
      background: #fff
      overflow-y: auto
      padding-bottom: 20px
      .historyTable
        overflow-y: auto
        background: $color-background-d
        width: 50%
        float: left;
        height: 100%
      .checkDetails
        float: right
        width: calc(50% - 40px)
        padding: 10px
        background: $color-background-d
        .DetailHead
          height: 30px
          line-height: 30px
          p
            width calc(100% - 20px - 80px)
            float: left
            font-weight: bold
            color: #000
          span
            float: left
            margin: 8px 5PX 0 0
            height: 16px
            width: 2px
            background: #000
          a
            float: right
            width: 80px
            height: 30px
            line-height: 30px
            text-align: center
            background: $color-background-hover
            color: $color-background-d
            border-radius: 3px

      .result-con
        //max-height: 180px
        overflow-y: hidden
        clear both
        .Image
        .Result
          overflow: hidden
          min-height: 100px
          margin-top: 10px
          color: #000
          span
            float: left
            width: 80px
            line-height: 26px
          .content
            line-height: 26px
            float: left
            width: calc(100% - 86px)

  .record
    overflow: hidden

  .record-left
    float: left
    width: 39%

  .record-right
    float: right
    width: 60%

  .shoucang
    display: block
    width: 160px
    height: 30px
    line-height: 30px
    text-align: center
    background: $color-background-hover
    color: $color-background-d
    border-radius: 3px
    margin: 20px auto 0

  .hui
    background:#c9cbd1 !important
    color:#fff !important

</style>



// WEBPACK FOOTER //
// viewReport.vue?5178127b